export default __webpack_public_path__ + "static/media/pvilla2-4.1e8f4c48.jpg";